import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromRoot from '@shared/store';

import * as fromMocketBank from './mocketbank-account.reducer';

export const mocketBankAccountFeatureKey = 'mocket-bank-account-store';

export interface MocketBankAccountState {
  [fromMocketBank.mocketBankAccountFeatureKey]: fromMocketBank.MocketBankAccountState;
}

export interface State extends fromRoot.RootState {
  [mocketBankAccountFeatureKey]: MocketBankAccountState;
}

export const reducers = (state: MocketBankAccountState | undefined, action: Action) => {
  return combineReducers({
    [fromMocketBank.mocketBankAccountFeatureKey]: fromMocketBank.reducer,
  })(state, action);
};

export const selectMocketBankAccountState = createFeatureSelector<MocketBankAccountState>(mocketBankAccountFeatureKey);

export const selectMocketBankAccountListState = createSelector(selectMocketBankAccountState, (state) => state?.mocketBankAccountPage);

export const selectMocketBankAccountItems = createSelector(selectMocketBankAccountListState, fromMocketBank.getMocketBankAccounts);

export const selectMocketBankAccountTotalElements = createSelector(selectMocketBankAccountListState, fromMocketBank.getTotalElements);

export const selectMocketBankAccountLoading = createSelector(selectMocketBankAccountListState, fromMocketBank.getLoading);

export const selectActiveMocketBankAccount = createSelector(selectMocketBankAccountListState, fromMocketBank.getSelectedMocketBankAccount);

export const selectMocketBankAccountError = createSelector(selectMocketBankAccountListState, fromMocketBank.getError);
